import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import { toCamelCase, copyInto } from '@/utilities';
import { Base } from '@/models';

export class EmailAttachment extends Base {

  public filename: string;
  public path: string;

  /**
   * Constructor
   */
  public constructor(data?: Partial<EmailAttachment>) {
    super(data);
    data = toCamelCase(data);

    this.filename = _get(data, 'filename', '');
    this.path = _get(data, 'path', '');
  }
}
